import { type ComponentProps } from 'react'
import styles from './ScopeChangeRequestBreakdownTable.module.css'

export type ScopeChangeRequestBreakdownTableProps = ComponentProps<'table'>

export function ScopeChangeRequestBreakdownTable(
  props: ScopeChangeRequestBreakdownTableProps,
) {
  return <table className={styles.root} {...props}></table>
}
